import React from "react";
import './styles.css'

const CommonCheckbox = ({ label, value, onChange, id, disabled = false, lableClass = '', showLabel = true, noWidth = false }) => {
    return (
        <div className={noWidth ? 'common-checkbox-container-no-width' : 'common-checkbox-container'}>
            <input
                type="checkbox"
                className="form-check-input common-checkbox"
                id={id}
                checked={value}
                value={value}
                onChange={onChange}
                disabled={disabled}
                required />
            {showLabel && <label for="name" className={`common-checkbox-label ${lableClass}`}>{label}</label>}
        </div>
    )
}

export default CommonCheckbox